import React from 'react'
import Container from '../components/Container'
import { ScrollFadeIn } from '../../../components/ScrollFadeIn'

const TestimonialTitle = () => {
  return (
      <Container bgColor='bg-white'>
          <div className="mx-auto text-center">
              <ScrollFadeIn>
                  <h1 className="heading-1 mx-auto italic">
                      Join the thousands of individuals and families across the country who have trusted us for ongoing financial advice.
                  </h1>
              </ScrollFadeIn>
          </div>
      </Container>
  )  
}

export default TestimonialTitle